import FilterDropdown from "@/features/filters/FilterDropdown.vue";
import SearchBarFilter from "@/features/filters/SearchBarFilter.vue";
import ToggleButtonFilter from "@/features/filters/ToggleButtonFilter.vue";
import ClearFilterButton from "@/features/filters/buttons/ClearFilterButton.vue";
import Separator from "@/components/header/Separator.vue";
import ControlPanel from "@/features/ControlPanel.vue";
import ControlPanelV2 from "@/features/ControlPanelV2.vue";
import FilterPanel from "@/features/filters/FilterPanel.vue";
import LogoDatePanel from "@/features/masthead/LogoDatePanel.vue";
import HelpButton from "@/components/buttons/HelpButton.vue";
import HelpButtonV2 from "@/components/buttons/HelpButtonV2";
import ToggleFilterButton from "@/components/buttons/ToggleFilterButton.vue";
import ZoomControls from "@/components/buttons/ZoomControls.vue";
import ZoomControlsV2 from "@/components/buttons/ZoomControlsV2.vue";
import ToggleFlyerOrientationButton from "@/components/buttons/ToggleFlyerOrientationButton.vue";
import ToggleFlyerOrientationButtonV2 from "@/components/buttons/ToggleFlyerOrientationButtonV2.vue";
import ToggleFullscreenButton from "@/components/buttons/ToggleFullscreenButton.vue";
import ToggleFullscreenButtonV2 from "@/components/buttons/ToggleFullscreenButtonV2.vue";
import pdfDownloadButton from "@/components/buttons/PdfDownloadButton.vue";
import pdfDownloadButtonV2 from "@/components/buttons/PdfDownloadButtonV2.vue";
import shoppingListToggleButton from "@/components/buttons/ShoppingListToggleButton.vue";
import shoppingListToggleButtonV2 from "@/components/buttons/ShoppingListToggleButtonV2.vue";
import FilterDrawerToggleButton from "@/features/filters/buttons/FilterDrawerToggleButton.vue";
import SearchBar from "@/features/filters/SearchBarFilterStandAlone.vue";
import HamburgerMenuButton from "@/components/buttons/HamburgerMenuButton.vue";
import HamburgerMenuButtonV2 from "@/components/buttons/HamburgerMenuButtonV2.vue";
import InlineFlyerSelector from "@/features/flyer-selector/inline/InlineFlyerSelector.vue";
import EmailSignupButton from "@/features/email-signup/emailSignupButton.vue";
import EmailSignupButtonV2 from "@/features/email-signup/emailSignupButtonV2.vue";
import RangeFilter from "@/features/filters/range/RangeFilter.vue";
import ShareButton from "@/features/share/ShareButton.vue";
import FavsButton from "@/features/favourites/favsButton.vue";
import {isArray, isObject} from "lodash";
import RaddarFilterToggleButton from "@/features/raddar/buttons/RaddarFilterToggleButton.vue";

//import vue from "vue";

const compDict = {
	filter: {
		'dropdown': FilterDropdown,
		'searchbar': SearchBarFilter,
		'toggle-button': ToggleButtonFilter,
		'clear-button': ClearFilterButton,
		'rangeList': RangeFilter
	},
	controlPanel: {
		'help': HelpButton,
		'filter-toggle': ToggleFilterButton,
		'zoom': ZoomControls,
		'orientation': ToggleFlyerOrientationButton,
		'fullscreen-toggle': ToggleFullscreenButton,
		'pdf-download': pdfDownloadButton,
		'other-flyers': null,
		'shopping-list': shoppingListToggleButton,
		'filter-drawer-toggle': FilterDrawerToggleButton,
		'search-bar': SearchBar,
		'hamburgerMenu': HamburgerMenuButton,
		'emailSignupButton': EmailSignupButton,
		'separator': Separator,
		'share': ShareButton,
		'favs': FavsButton,
		'raddar-filter-toggle': RaddarFilterToggleButton
	},
	controlPanelV2: {
		'help': HelpButtonV2,
		'filter-toggle': ToggleFilterButton,
		'zoom': ZoomControlsV2,
		'orientation': ToggleFlyerOrientationButtonV2,
		'fullscreen-toggle': ToggleFullscreenButtonV2,
		'pdf-download': pdfDownloadButtonV2,
		'other-flyers': null,
		'shopping-list': shoppingListToggleButtonV2,
		'filter-drawer-toggle': FilterDrawerToggleButton,
		'search-bar': SearchBar,
		'hamburgerMenu-v2': HamburgerMenuButtonV2,
		'emailSignupButton': EmailSignupButtonV2,
		'separator': Separator,
		'share': ShareButton,
		'favs': FavsButton,
		'raddar-filter-toggle': RaddarFilterToggleButton
	},
	header: {
		filterPanel: FilterPanel,
		separator: Separator,
		controls: ControlPanel,
		controlsV2: ControlPanelV2,
		mastHead: LogoDatePanel,
		hamburgerMenu: HamburgerMenuButton
	},
	app: {
		inlineFlyerSelector: InlineFlyerSelector
	}
}

/*for(let p in compDict) {
	const sects = compDict[p];
	console.log('CompDict:', sects);
	for(let s in sects) {
		const comp = sects[s];
		if(comp?.name){
			console.log('Register Comp:', comp);
			vue.component(comp.name, comp);
		}
	}
}*/

//export const featureCompDict = compDict;
export const filterDict = compDict.filter;
export const controlDict = compDict.controlPanel;
export const controlDictV2 = compDict.controlPanelV2;
export const headerDict = compDict.header;

export const appDict = compDict.app;

/**
 * Search object and return a list of objects paths that contain the key
 * @param o - Object to search
 * @param key - Property to match
 * @param result - an array of object paths
 * @param depth - how deep to search
 * @param path
 * @returns null | String[]
 */
export function findPathsByKey(o, key, result = [], depth = 10, path = null) {
	if(depth <= 0)return null;
	for(let p in o) {
		const pv = o[p];
		if(p === key) {
			result.push(path);
		} else if (typeof pv === 'object') {
			findPathsByKey(pv, key, result, depth - 1, Array.isArray(o)? `${path}[${p}]`: (!path)? p: `${path}.${p}`);
		}
	}
	return result;
}

/**
 * returns an array of components {component, name, attrs}
 * @param {array} items
 * @param dict - Component Dictionary
 * @returns {*[]}
 * @constructor
 */
export function FeatureJsonToComponents(items, dict) {
	const o = [];
	if(isArray(items)) {
		//const dict = headerDict;// featureCompDict.header;
		// console.log('header dict:', dict);
		for(let p of items) {
			/*console.log('inlineItems:', p, dict[p])*/
			let name = p;
			let props = {};
			if(isObject(p) && p?.name) {
				console.log('Inline Item is an Object:', p);
				let {name: compName, ...rest} = p;
				name = compName;
				props = rest;

				console.log('Name:', name, ' Props:', props);
			}
			if(dict[name]) {
				const component = dict[name];
				o.push({component, name, attrs:props})
			}
		}
	}
	return o;
}
